<template>
  <div>
    <Card>
      <!-- <Row>
        <Button type="info" @click="add">添加</Button>
      </Row> -->
      <TablePaginate
        :columns="columns"
        :data="shops"
        :loading="loading"
        :meta="meta"
        :changePage="changePage"
      ></TablePaginate>
    </Card>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { find } from 'lodash'
import TablePaginate from '@/components/TablePaginate'
import { booleanChinese } from '@/libs/table-render'

export default {
  components: {
    TablePaginate
  },
  data () {
    const vm = this
    return {
      modalShow: false,
      modalShow2: false,
      id: this.$route.params.id,
      columns: [
        {
          title: 'ID',
          key: 'id'
        },
        {
          title: '店铺名',
          key: 'name'
        },
        {
          title: '所属连锁店',
          align: 'center',
          key: 'chain_store_name'
        },
        {
          title: '在线支付',
          align: 'center',
          key: 'lcsw_account_status'
        },
        {
          title: '关闭会员充值',
          align: 'center',
          render: (h, params) => {
            return booleanChinese(h, params.row.charge_close)
          }
        },
        {
          title: '软件版本',
          align: 'center',
          render: (h, params) => {
            return h(
              'div',
              find(vm.fresh_software_versions, { name: params.row.software_version_name }).title || params.row.software_version_name
            )
          }
        }
        // {
        //   title: '激活时间',
        //   width: 200,
        //   align: 'center',
        //   key: 'activated_at_str'
        // }
      ]
    }
  },
  created () {
    this.changeQuery({ page: 1 })
    this.index({ chain_store_id: this.id })
    this.versionsIndex()
  },
  computed: {
    ...mapGetters('shop', ['shop', 'shops', 'meta', 'loading']),
    ...mapGetters('fresh_software_version', ['fresh_software_versions'])
  },
  methods: {
    ...mapActions('shop', [
      'clear',
      'index',
      'show',
      'create',
      'update',
      'destroy',
      'activate',
      'shop_reduce'
    ]),
    ...mapActions('fresh_software_version', { versionsIndex: 'index' }),
    ...mapMutations('shop', ['changeQuery']),
    add () {
      this.clear()
      this.modalShow = true
      this.formType = 'new'
    },
    changePage (page) {
      this.changeQuery({ page: page })
      this.index({ chain_store_id: this.id })
    },
    shop_select (shop_id) {
      this.index({ chain_store_id: this.id })
    },
    shop_upgrade (id) {
      this.clear()
      this.modalShow2 = true
    },
    async handleSubmit () {
      if (this.formType === 'edit') {
        await this.update(this.shop)
      } else if (this.formType === 'new') {
        await this.create(this.shop)
      }
      this.modalShow = false
    }
  }
}
</script>
